const moveMailSuccess = 'movingMailSuccess'
const modifyTagSuccess = 'modifyTagSuccess'
export {
    moveMailSuccess,
    modifyTagSuccess
}
